import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c641948"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paddingLine" }, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ant-rate-text" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"-6px"} }, "附件：", -1))
const _hoisted_7 = { class: "button" }

import { ref, computed } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import UploadFile from '@/components/UploadFile'
import Modal from '@/hooks/modalType'
import type { LbuSaleCoachingCommentItem } from '@/typings/api/saleCoaching'
import { saleCoachingDetail, saleCoachingCommentDelete } from '@/api/yuntuSales/saleCoaching'
import xss from 'xss'
import { number } from 'vue-types'

const __default__ = {
  name: 'commitList'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Array,
    default: () => {
      return []
    }
  },
  score: {
    type: number,
    default: () => {
      return 0
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  id: String
},
  setup(__props, { expose: __expose }) {

const props = __props
const hasfetch = ref(false)
const commentList = ref([])
const pageData = computed(() => {
  if (hasfetch.value) {
    return commentList.value
  }
  return props.data || []
})

const score = computed(() => {
  return props.score
})

const refresh = () => {
  saleCoachingDetail({ id: props.id }).then((res) => {
    hasfetch.value = true
    commentList.value = res.data.commentList
  })
}
const commentDesc = ref<string[]>(['非常不满意', '不满意', '一般', '满意', '非常满意'])

const handleDelCol = (row: LbuSaleCoachingCommentItem) => {
  Modal.delete({
    onOk() {
      saleCoachingCommentDelete({ id: row.id }).then((res) => {
        DcMessage.success('删除成功')
        refresh()
      })
    }
  })
}
__expose({
  refresh
})

return (_ctx: any,_cache: any) => {
  const _component_a_rate = _resolveComponent("a-rate")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_dc_layout_card, {
      title: "评论记录",
      isAutoLayout: false
    }, {
      default: _withCtx(() => [
        (props.score > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_a_rate, {
                style: {"margin-bottom":"16px"},
                value: score.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((score).value = $event)),
                disabled: true,
                tooltips: commentDesc.value
              }, null, 8, ["value", "tooltips"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(commentDesc.value[props.score - 1]), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "commit-list",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(item.createByName), 1),
              _createElementVNode("p", null, _toDisplayString(item.createTime), 1)
            ]),
            _createElementVNode("div", {
              innerHTML: _unref(xss)(item.content)
            }, null, 8, _hoisted_5),
            (item.fileId && item.fileId.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_6,
                  _createVNode(_unref(UploadFile), {
                    value: item.fileId,
                    "onUpdate:value": ($event: any) => ((item.fileId) = $event),
                    view: "",
                    valueType: "array"
                  }, null, 8, ["value", "onUpdate:value"])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "text",
                onClick: ($event: any) => (handleDelCol(item)),
                danger: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, __props.permissionPage.delCommit]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})